// extracted by mini-css-extract-plugin
export default {"icon":"s_icon__dxRQ6","rotate":"s_rotate__WWLYk"};